/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { ICellPresenter_$type } from "./ICellPresenter";
import { CellModel } from "./CellModel";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasCellPresenterBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasCellPresenterBase, _super);
    function CanvasCellPresenterBase(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    CanvasCellPresenterBase.prototype.modelUpdated = function (a) {
        this.b(a);
    };
    CanvasCellPresenterBase.prototype.b = function (a) {
        this.a.b8(a.c);
        if (a.aw(CellModel.dx) || a.aw(CellModel.d1) || a.aw(CellModel.dz) || a.aw(CellModel.dv)) {
            this.a.cg(a.dw, a.d0, a.dy, a.du);
        }
        if (a.ap) {
            this.a.ca(a.j2, a.dj, a.dp, a.dm, a.dh);
        }
        if (a.a7) {
            this.a.cd(a.ev);
            this.a.cn(a.f8);
        }
        if (a.ar) {
            if (a.a1 && !this.a.u) {
                this.a.by();
            }
            if (a.aw(CellModel.dg)) {
                this.a.b9(a.j1.color);
            }
            if (a.aw(CellModel.dt)) {
                this.a.cf(a.bw);
            }
        }
        if (a.a7 && a.a1) {
            this.a.cq(a);
        }
    };
    CanvasCellPresenterBase.prototype.c = function (a, b, c) {
        if (c == 0) {
            return a.color;
        }
        if (c == 1) {
            return b.color;
        }
        var d = BrushUtil.k(a, c, b, 0);
        return d.color;
    };
    Object.defineProperty(CanvasCellPresenterBase.prototype, "nativeCell", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasCellPresenterBase.prototype, "isCanvasBased", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    CanvasCellPresenterBase.$t = markType(CanvasCellPresenterBase, 'CanvasCellPresenterBase', Base.$, [ICellPresenter_$type]);
    return CanvasCellPresenterBase;
}(Base));
export { CanvasCellPresenterBase };
//# sourceMappingURL=CanvasCellPresenterBase.js.map
